module.exports = __webpack_public_path__ + "static/media/singapore.11bf5565.svg";